import React, { useEffect, useState, useRef, useMemo } from "react";
import report from "./reports";

import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Select,
  Spin,
} from "antd";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Modal } from "antd";
import { Avatar, Badge, Space } from "antd";
import { Bar } from "react-chartjs-2";
import { Doughnut } from "react-chartjs-2";
import ConsingmentReport from "./consingmentreporttab/consingmentreport";
import ExportIcon from "../../assets/images/export-svgrepo-com (1).svg";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import filtericon from "../../assets/images/filter-svgrepo-com (1).svg";
import { CSVLink } from "react-csv";
import { ArcElement, Chart } from "chart.js";
import { CALL_API } from "../../Common/api";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { ButtonFilled } from "../../Reusablecomponents/UIButtons";
import styled from "styled-components";
import { handleDownloadChart } from "../../Reusablecomponents/Export/Exportpdf";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";

const StyledChartContainer = styled.div`
  .filterstyle {
    height: 20px;
    width: 20px;
  }
  .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    font-size: 16px;
    font-weight: 500;
  }
  .total-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
  }
  .container_triptimming {
    margin: 40px 0px 0px 0px;
  }
`;

const { Option } = Select;
const { RangePicker } = DatePicker;
Chart.register(ArcElement);

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
);

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  ChartDataLabels,
);

const ReportsPage = () => {
  const [form] = Form.useForm();
  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("TRPT", "EX"),
    [reduxPermissions],
  );
  const [visible, setVisible] = useState(false);
  const handleTooltipVisibleChange = (visible) => {
    setVisible(visible);

    if (visible) {
      setTimeout(() => {
        const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
        tooltipArrows.forEach((arrow) => {
          arrow.style.display = "none"; // Hide the arrow
        });
      }, 0);
    }
  };
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  // const userInfo  = {MCID :71}
  const [tabhidden, setTabHidden] = useState(true);
  const [loading, setLoading] = useState(false);
  const [tripCount, setTripCount] = useState({});
  const [duration, setDuration] = useState("current_month");
  const [selectedDate, setSelectedDate] = useState(null);
  const [filterCount, setFilterCount] = useState(0);
  const [formValues, setFormValues] = useState({});
  const [tripChartData, setTripChartData] = useState([]);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const csvLinkEl = useRef();
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };
  const getTripCount = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `trip/getTripReporTotal?MCID=${userInfo?.MCID}&startDate=${dayjs(
          selectedDate[0],
        ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}`,
        {
          Vehid: formValues?.vehicle || 0,
          Cust: formValues?.consignor || 0,
          Shipper: formValues?.transporter || 0,
          Receiver: formValues?.consignee || 0,
          Triptype: formValues?.tripType || 0,
          Driver: formValues?.driver || 0,
          Tripcode: formValues?.tripcode || 0,
          code: formValues?.consigncode || 0,
        },
      );
      setTripCount(data);
      setLoading(false);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  const getTripChartData = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `trip?MCID=${userInfo?.MCID}&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=${currentPage}&PageSize=${pageSize} `,
        {
          Vehid: formValues?.vehicle || 0,
          Cust: formValues?.consignor || 0,
          Shipper: formValues?.transporter || 0,
          Receiver: formValues?.consignee || 0,
          Triptype: formValues?.tripType || 0,
          Driver: formValues?.driver || 0,
          Tripcode: formValues?.tripcode || 0,
          code: formValues?.consigncode || 0,
        },
      );
      setTripChartData(data);
      setTotal(data?.TimeReport[0]?.TotalCount || 0);
      setLoading(false);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  const getFilterCount = () => {
    const value = form.getFieldsValue() || {};
    const count = Object.values(value).filter(
      (val) => val && val.length !== 0,
    ).length;

    setFilterCount(count);
  };
  //export functionality for trip time reprt tabel
  const prepareCSV = async () => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API(
        "POST",
        `trip?MCID=${userInfo?.MCID}&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=1&PageSize=${total}`,
        {
          Vehid: formValues?.vehicle || 0,
          Cust: formValues?.consignor || 0,
          Shipper: formValues?.transporter || 0,
          Receiver: formValues?.consignee || 0,
          Triptype: formValues?.tripType || 0,
          Driver: formValues?.driver || 0,
          Tripcode: formValues?.tripcode || 0,
          code: formValues?.consigncode || 0,
        },
      );

      if (data?.TimeReport?.length > 0) {
        // Apply sorting to match table sort order
        const sortedData = applySorting(data?.TimeReport);

        setCSVList(
          sortedData?.map((item) => ({
            "Trip Code": item.CODE || "-",
            "Pickup Date & Time": item.PICKUPDATETIME
              ? dayjs(item.PICKUPDATETIME).format("DD/MM/YYYY HH:mm:ss")
              : "---",
            Vehicle: item.REGNO || "-",
            "ODO (Kms)": item.ODO || "-",
            "ODO Start": item.ODOSTART || "-",
            "ODO END": item.ODOEND || "-",
            "Carbon Footprint (KgCo2)": item.CarbonFootprint || "-",
            "Driver Name": item.DRIVERNAME || "-",
            "Trip Type": item.Triptype
              ? item.Triptype === 1
                ? "Local"
                : "Safari"
              : "-",
            "Loading Waiting Time": item.LOADINGWAITINGTIME
              ? formattedTime(item.LOADINGCYCLE)
              : "-",
            "Loading Time": item.LOADINGTIME
              ? formattedTime(item.LOADINGCYCLE)
              : "-",
            "Time After Loading": item.TIMEAFTEROFFLOADING
              ? formattedTime(item.LOADINGCYCLE)
              : "-",
            "Offloading Waiting Time": item.OFFLOADINGWAITINGTIME
              ? formattedTime(item.LOADINGCYCLE)
              : "-",
            "Offloading Time": item.OFFLOADINGWAITINGTIME
              ? formattedTime(item.LOADINGCYCLE)
              : "-",
            "Time After Offloading": item.TIMEAFTEROFFLOADING
              ? formattedTime(item.LOADINGCYCLE)
              : "-",
            "Break Time": item.BreakTime
              ? formattedTime(item.LOADINGCYCLE)
              : "-",
            "Loading Cycle": item.LOADINGCYCLE
              ? formattedTime(item.LOADINGCYCLE)
              : "-",
            "Offloading Cycle": item.OFFLOADINGCYCLE
              ? formattedTime(item.OFFLOADINGCYCLE)
              : "-",
            "Travel Time": formattedTime(item.TRAVELTIME) || "",
          })),
        );

        setTimeout(() => {
          csvLinkEl.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
      message.error(
        "Failed to prepare CSV. " + (error?.response?.data?.message || ""),
      );
    } finally {
      setCSVLoader(false);
    }
  };

  useEffect(() => {
    getTripCount();
  }, [formValues, selectedDate]);

  useEffect(() => {
    getTripChartData();
  }, [formValues, selectedDate, currentPage, pageSize]);

  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  const tripStatusList = tripCount?.TripStatus ?? [];

  const localData = tripStatusList.find((t) => t.TripType === "Local") || {};
  const safariData = tripStatusList.find((t) => t.TripType === "Safari") || {};

  const labels = ["Not Started", "In Progress", "Completed"];

  const data = {
    labels,
    datasets: [
      {
        label: "Local",
        data: [localData.NotStarted, localData.InProgress, localData.Completed],
        backgroundColor: "#f39c12",
      },
      {
        label: "Safari",
        data: [
          safariData.NotStarted,
          safariData.InProgress,
          safariData.Completed,
        ],
        backgroundColor: "#3498db",
      },
    ],
  };
  const Baroptions = {
    indexAxis: "y", // Horizontal bar chart
    scales: {
      x: {
        beginAtZero: true,
        stacked: true,
        grid: { display: false },
      },
      y: {
        stacked: true,
        grid: { display: false },
      },
    },
    responsive: true,
    barThickness: 35,
    maxBarThickness: 35,
    plugins: {
      legend: {
        display: true,
        align: "end",
        position: "top",
        labels: {
          boxWidth: 12, // width of the color box
          boxHeight: 12, // height of the color box (make square)
          usePointStyle: false, // set to true if you want a circle instead
          padding: 15,
          font: {
            size: 16,
            weight: "bold",
          },
        },
      },
      datalabels: {
        display: true,
        anchor: "center", // position relative to bar
        align: "center", // put above the bar
        offset: 4, // spacing
        color: "#000",
        font: {
          size: 16,
          weight: "500",
        },
        formatter: (value) => value,
      },
    },
  };

  const formattedTime = (totalSeconds) => {
    if (!totalSeconds || totalSeconds <= 0) return "00:00:00";

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const hh = hours.toString().padStart(2, "0");
    const mm = minutes.toString().padStart(2, "0");
    const ss = seconds.toString().padStart(2, "0");

    return `${hh}:${mm}:${ss}`;
  };

  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting = (data) => {
    if (!tableSort.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal = a[tableSort.field];
      let bVal = b[tableSort.field];

      // Handle numeric fields
      if (
        [
          "ODO",
          "CarbonFootprint",
          "LOADINGCYCLE",
          "OFFLOADINGCYCLE",
          "triptype",
        ].includes(tableSort.field)
      ) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort.order === "ascend" ? result : -result;
    });

    return sorted;
  };

  const columns = [
    {
      title: "Trip Code",
      dataIndex: "CODE",
      key: "CODE",
      sorter: (a, b) => (a.CODE || "").localeCompare(b.CODE || ""),
      sortOrder: tableSort.field === "CODE" ? tableSort.order : null,
      render: (text) => <span style={{ color: "#1D4174" }}>{text}</span>,
    },
    {
      title: "Pickup Date & Time",
      dataIndex: "PICKUPDATETIME",
      key: "PICKUPDATETIME",
      sorter: (a, b) =>
        (a.PICKUPDATETIME || "").localeCompare(b.PICKUPDATETIME || ""),
      sortOrder: tableSort.field === "PICKUPDATETIME" ? tableSort.order : null,
      render: (value) => {
        return <>{value ? dayjs(value).format("DD/MM/YYYY") : "---"}</>;
      },
    },
    {
      title: "Vehicle",
      dataIndex: "REGNO",
      key: "REGNO",
      sorter: (a, b) => (a.REGNO || "").localeCompare(b.REGNO || ""),
      sortOrder: tableSort.field === "REGNO" ? tableSort.order : null,
    },
    {
      title: "ODO (Kms)",
      dataIndex: "ODO",
      key: "ODO",
      sorter: (a, b) => (a.ODO || 0) - (b.ODO || 0),
      sortOrder: tableSort.field === "ODO" ? tableSort.order : null,
      render: (value) => value ?? "-",
    },
    {
      title: "Carbon Footprint (KgCo2)",
      dataIndex: "CarbonFootprint",
      key: "CarbonFootprint",
      sorter: (a, b) => (a.CarbonFootprint || 0) - (b.CarbonFootprint || 0),
      sortOrder: tableSort.field === "CarbonFootprint" ? tableSort.order : null,
      render: (value) => value ?? "-",
    },
    {
      title: "Driver Name",
      dataIndex: "DRIVERNAME",
      key: "DRIVERNAME",
      sorter: (a, b) => (a.DRIVERNAME || "").localeCompare(b.DRIVERNAME || ""),
      sortOrder: tableSort.field === "DRIVERNAME" ? tableSort.order : null,
    },
    {
      title: "Trip Type",
      dataIndex: "triptype",
      key: "triptype",
      sorter: (a, b) => (a.triptype || 0) - (b.triptype || 0),
      sortOrder: tableSort.field === "triptype" ? tableSort.order : null,
      render: (_, record) => {
        return record.Triptype === 1 ? "Local" : "Safari";
      },
    },
    {
      title: "Loading Cycle",
      dataIndex: "LOADINGCYCLE",
      key: "LOADINGCYCLE",
      sorter: (a, b) => (a.LOADINGCYCLE || 0) - (b.LOADINGCYCLE || 0),
      sortOrder: tableSort.field === "LOADINGCYCLE" ? tableSort.order : null,
      render: (val) => {
        return formattedTime(val);
      },
    },
    {
      title: "Offloading Cycle",
      dataIndex: "OFFLOADINGCYCLE",
      key: "OFFLOADINGCYCLE",
      sorter: (a, b) => (a.OFFLOADINGCYCLE || 0) - (b.OFFLOADINGCYCLE || 0),
      sortOrder: tableSort.field === "OFFLOADINGCYCLE" ? tableSort.order : null,
      render: (val) => {
        return formattedTime(val);
      },
    },
  ];

  // Step 1: Get individual times safely
  const safeValue = (v) => (v !== null && v !== undefined ? v : 0);

  const formatDuration = (minutes) => {
    if (minutes == null || isNaN(minutes)) return "00:00";

    const days = Math.floor(minutes / (24 * 60));
    const hours = Math.floor((minutes % (24 * 60)) / 60);
    const mins = minutes % 60;

    if (days > 0) {
      return `${String(days).padStart(2, "0")}:${String(hours).padStart(
        2,
        "0",
      )}:${String(mins).padStart(2, "0")}`;
    } else {
      return `${String(hours).padStart(2, "0")}:${String(mins).padStart(
        2,
        "0",
      )}`;
    }
  };
  const formatTotalDuration = (minutes) => {
    if (minutes == null || isNaN(minutes)) return "00:00";

    const days = Math.floor(minutes / (24 * 60));
    const hours = Math.floor((minutes % (24 * 60)) / 60);
    const mins = minutes % 60;

    if (days > 0) {
      return `${String(days).padStart(2, "0")}:${String(hours).padStart(
        2,
        "0",
      )}:${String(mins).padStart(2, "0")}`;
    } else {
      return `${String(hours).padStart(2, "0")}:${String(mins).padStart(
        2,
        "0",
      )}`;
    }
  };

  const formatTotalHours = (totalSeconds) => {
    if (!totalSeconds || totalSeconds <= 0) return "0 hrs";

    const totalHours = Math.floor(totalSeconds / 3600); // ignore minutes
    return `${totalHours} hrs`;
  };

  const timeList = tripCount?.TimeReportChart ?? [];
  const itemCount = timeList.length || 1; // prevent divide by zero

  const sum = (key) =>
    timeList.reduce((sum, item) => sum + safeValue(item?.[key]), 0);

  const avgLoadingCycle = sum("loadingCycle") / itemCount;
  const avgOffloadingCycle = sum("offloadingCycle") / itemCount;
  const avgLoadingTime = sum("loadingtime") / itemCount;
  const avgOffloadingTime = sum("offloadingtime") / itemCount;
  const avgLoadingWait = sum("loadingwaitingtime") / itemCount;
  const avgOffloadingWait = sum("offloadingwaitingtime") / itemCount;
  const avgTimeAfterLoading = sum("timeafterloading") / itemCount;
  const avgTimeAfterOffloading = sum("timeafteroffloading") / itemCount;

  const values = [
    { label: "Loading Cycle", color: "rgb(13,178,24)", time: avgLoadingCycle },
    { label: "Loading Time", color: "rgb(0,213,14)", time: avgLoadingTime },
    {
      label: "Loading Wait Time",
      color: "rgb(7,247,23)",
      time: avgLoadingWait,
    },
    {
      label: "Time After Loading",
      color: "rgb(154,255,161)",
      time: avgTimeAfterLoading,
    },
    {
      label: "Offloading Cycle",
      color: "rgb(255,161,213)",
      time: avgOffloadingCycle,
    },
    {
      label: "Offloading Time",
      color: "rgb(255,100,185)",
      time: avgOffloadingTime,
    },
    {
      label: "Offloading Wait Time",
      color: "rgb(243,0,133)",
      time: avgOffloadingWait,
    },
    {
      label: "Time After Offloading",
      color: "rgb(190,0,104)",
      time: avgTimeAfterOffloading,
    },
  ];

  const avgTotalTimeTaken = values
    .filter(
      (v) => v.label !== "Loading Cycle" && v.label !== "Offloading Cycle",
    )
    .reduce((sum, v) => sum + v.time, 0);

  const centerTextPlugin = {
    id: "centerText",
    beforeDraw(chart) {
      const { ctx } = chart;
      const total = chart.config.options.plugins?.centerText?.totalTime || 0;
      const centerValue = "Time Taken";
      const formatted = formatDuration(total);
      ctx.save();
      ctx.font = "bold 22px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "rgb(135,145,169)";

      const { width, height } = chart;
      const x = width / 2;
      // For half-doughnut, center vertically in the visible area
      const y = height / 1.35; // adjust this value as needed

      ctx.fillText(centerValue, x, y - 10);
      ctx.font = "normal 18px Arial";
      ctx.fillText(formatted, x, y + 22);
      ctx.restore();
    },
  };

  // Step 3: Calculate total for percentage calculation
  const totalTime = values.reduce((sum, item) => sum + item.time, 0);

  // Step 4: Build final chart legend data with % values
  const chartLegendData = values.map((item) => ({
    ...item,
    formattedTime: formatTotalDuration(item.time), // Correct property name is formattedTime
    percentage:
      avgTotalTimeTaken > 0
        ? `${((item.time / avgTotalTimeTaken) * 100).toFixed(2)}%`
        : "",
  }));

  const left = chartLegendData.slice(0, 4);
  const right = chartLegendData.slice(4);

  const renderLegendItems = (items) =>
    items.map((item, index) => (
      <div
        key={index}
        style={{ display: "flex", alignItems: "center", marginBottom: 5 }}
      >
        <span
          style={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: item.color,
            display: "inline-block",
            marginRight: 5,
          }}
        />
        <span style={{ flex: 1, color: "#4b5563", fontSize: 14 }}>
          {item.label}
        </span>
        <span
          style={{ color: "#6b7280", fontSize: 14, fontFamily: "monospace" }}
        >
          {item.formattedTime}
          {item.percentage && (
            <span style={{ marginLeft: 6, color: "#9ca3af" }}>
              ({item.percentage})
            </span>
          )}
        </span>
      </div>
    ));

  const doughnutData = {
    labels: values.map((v) => v.label),
    datasets: [
      {
        data: values.map((v) => v.time),
        backgroundColor: values.map((v) => v.color), // <-- important
        borderWidth: 0,
        cutout: "75%",
      },
    ],
  };

  const doughnutOptions = {
    rotation: -90, // Start angle of the gauge (start from top)
    circumference: 180, // Half-circle (180 degrees)
    plugins: {
      legend: {
        display: false, // Hide the legend
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            const label = context.label || "";
            return `${label}: ${formatTotalDuration(value)}`;
          },
        },
        labelColor: function (context) {
          return {
            borderColor: context.dataset.backgroundColor[context.dataIndex],
            backgroundColor: context.dataset.backgroundColor[context.dataIndex],
          };
        },
      },
      centerText: {
        totalTime: avgTotalTimeTaken,
      },
      datalabels: {
        display: false, //  Prevents Bar chart datalabels from affecting this
      },
    },
  };
  const handleClick = () => {
    setTabHidden(true);
  };

  const handleClickreport = () => {
    setTabHidden(false);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];

  return (
    <Card>
      <StyledChartContainer>
        {tabhidden ? (
          <>
            <div>
              <div style={report.reportleftcontainer}>
                <Button
                  type="primary"
                  onClick={() => handleClick()}
                  style={report.tripbtn}
                >
                  Trip Time Report
                </Button>

                <Button
                  type="primary"
                  onClick={() => handleClickreport()}
                  style={report.consingmentbtn}
                >
                  Consignment Report
                </Button>
              </div>

              <div style={report.firstcontan}>
                <div style={report.overview}>
                  <span>Overview</span>
                </div>

                <div style={report.controls}>
                  <div style={report.subcontainer}>
                    <Select
                      style={{ width: "240px" }}
                      defaultValue={duration}
                      onChange={(values) => {
                        setDuration(values);
                      }}
                    >
                      {Duration.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item?.label}
                        </Option>
                      ))}
                    </Select>
                  </div>

                  <div style={report.subcontainer}>
                    <RangePicker
                      value={selectedDate}
                      onChange={(date, dateString) => setSelectedDate(date)}
                    />
                  </div>

                  <div style={report.subcontainer}>
                    <Button style={report.filterbtn} onClick={showModal}>
                      <Space size="middle">
                        <Badge size="small" count={filterCount}>
                          <Avatar
                            shape="circle"
                            size="medium"
                            src={filtericon}
                            className="filterstyle"
                          />
                        </Badge>
                      </Space>
                    </Button>
                  </div>
                  <Modal
                    open={isModalOpen}
                    onCancel={handleCancel}
                    width={900}
                    footer={
                      <ButtonFilled
                        onClick={() => {
                          form.resetFields();
                          setFormValues({});
                        }}
                      >
                        {" "}
                        Clear All{" "}
                      </ButtonFilled>
                    }
                  >
                    <Row>
                      <Col xl={24} xs={{ span: 24, order: 2 }}>
                        <div className="container_for_kpi_filter">
                          <h6 className="Filter_for_clickablerow">
                            Filter ({filterCount})
                          </h6>
                          {/* <p className="Filter_for_Result">4 Result Found </p> */}
                        </div>
                      </Col>
                    </Row>
                    <Form
                      form={form}
                      layout="vertical"
                      onValuesChange={(value, allvalues) => {
                        getFilterCount();
                        setFormValues(allvalues);
                      }}
                    >
                      <Row gutter={16}>
                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Vehicle" name="vehicle">
                            <Select
                              className="w-100"
                              showSearch
                              optionFilterProp="children"
                              options={vehicleList?.map((item) => ({
                                label: item.REGNO,
                                value: item.VEHID,
                              }))}
                              filterOption={(input, option) =>
                                option?.label
                                  ?.toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              allowClear
                              // suffixIcon={<SearchOutlined className="search_icon" />}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Consignor" name="consignor">
                            <Select
                              className="w-100"
                              showSearch
                              optionFilterProp="children"
                              options={consignerList?.map((item) => ({
                                label: item.Name,
                                value: item.ID,
                              }))}
                              filterOption={(input, option) =>
                                option?.label
                                  ?.toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              allowClear
                              // suffixIcon={<SearchOutlined className="search_icon" />}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Transporter" name="transporter">
                            <Select
                              className="w-100"
                              showSearch
                              optionFilterProp="children"
                              options={transporterList?.map((item) => ({
                                label: item.Name,
                                value: item.ID,
                              }))}
                              filterOption={(input, option) =>
                                option?.label
                                  ?.toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              allowClear
                              // suffixIcon={<SearchOutlined className="search_icon" />}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Consignee" name="consignee">
                            <Select
                              className="w-100"
                              showSearch
                              optionFilterProp="children"
                              options={consigneeList?.map((item) => ({
                                label: item.Name,
                                value: item.ID,
                              }))}
                              filterOption={(input, option) =>
                                option?.label
                                  ?.toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              allowClear
                              // suffixIcon={<SearchOutlined className="search_icon" />}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Consign Code" name="consigncode">
                            <Input placeholder="" className="rounded-pill" />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Trip Code" name="tripcode">
                            <Input placeholder="" className="rounded-pill" />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Trip Type" name="tripType">
                            <Select
                              className="w-100"
                              showSearch
                              allowClear
                              // suffixIcon={<SearchOutlined className="search_icon" />}
                            >
                              <Option value={2}>Safari</Option>
                              <Option value={1}>Local</Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Driver" name="driver">
                            <Select
                              className="w-100"
                              showSearch
                              optionFilterProp="children"
                              options={driverList?.map((item) => ({
                                label: item.FULLNM,
                                value: item.UID,
                              }))}
                              filterOption={(input, option) =>
                                option?.label
                                  ?.toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              allowClear
                              // suffixIcon={<SearchOutlined className="search_icon" />}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </Modal>
                </div>
              </div>
            </div>
            <Spin spinning={loading}>
              <div style={report.numberbox}>
                <div style={report.box1}>
                  {" "}
                  <span>
                    {" "}
                    <h5 style={report.tripshead}>Total No of Trips</h5>{" "}
                  </span>{" "}
                  <br />
                  <label>
                    {" "}
                    <h5>{tripCount?.TotalTrips?.[0]?.TotalTrips || 0}</h5>{" "}
                  </label>
                  <br />
                  <div style={report.verticalLine}></div>
                </div>

                <div style={report.box1}>
                  {" "}
                  <span>
                    <h5>
                      {userInfo?.MCID === 71 ? "Delivery" : "Local"}{" "}
                    </h5>{" "}
                  </span>{" "}
                  <br />
                  <label>
                    <h5>{tripCount?.LocalTrips?.[0]?.LocalTrips || 0} </h5>{" "}
                  </label>
                  <div style={report.verticalLine}></div>
                </div>
                <div style={{ ...report.box1, ...report.lastBox }}>
                  <span>
                    {" "}
                    <h5>
                      {userInfo?.MCID === 71 ? "Collection" : "Safari"}{" "}
                    </h5>{" "}
                  </span>{" "}
                  <br />
                  <label>
                    <h5>
                      {tripCount?.SafariTrips?.[0]?.SafariTrips || 0}{" "}
                    </h5>{" "}
                  </label>
                </div>
              </div>
            </Spin>
            <StyledChartContainer>
              <Row gutter={24} className="mt-4">
                <Col xs={24} sm={12}>
                  <Card style={{ height: "450px" }}>
                    <div id="Export Chart">
                      <Spin spinning={loading}>
                        <div className="chart-header">
                          <p className="pb-0 mb-0">Trip Status</p>
                          {/* <Tooltip
                            title={!exportAllowed ? "No permission" : ""}
                          > */}
                            <img
                              src={ExportIcon}
                              alt="Export"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: exportAllowed
                                  ? "pointer"
                                  : "not-allowed",
                                backgroundColor: "#EBF7ED",
                                borderRadius: "6px",
                              }}
                              onClick={() => {
                                if (!exportAllowed) return;
                                handleDownloadChart(
                                  "Export Chart",
                                  "Trip Status",
                                );
                              }}
                            />
                          {/* </Tooltip> */}
                        </div>
                        <Bar
                          data={data}
                          options={Baroptions}
                          plugins={[ChartDataLabels]}
                        />
                      </Spin>
                    </div>
                  </Card>
                </Col>

                <Col xs={24} sm={12}>
                  <Card style={{ height: "450px" }}>
                    <div id="Export Chart1">
                      <Spin spinning={loading}>
                        <div className="chart-header">
                          <p className="pb-0 mb-0">Trip Timing</p>
                          {/* <Tooltip
                            title={!exportAllowed ? "No permission" : ""}
                          > */}
                            <img
                              src={ExportIcon}
                              alt="Export"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: exportAllowed
                                  ? "pointer"
                                  : "not-allowed",
                                marginRight: "40px",
                                backgroundColor: "#EBF7ED",
                                borderRadius: "6px",
                              }}
                              onClick={() => {
                                if (!exportAllowed) return;
                                handleDownloadChart(
                                  "Export Chart1",
                                  "Trip Timing",
                                );
                              }}
                            />
                          {/* </Tooltip> */}
                        </div>
                        <div
                          style={{ width: 300, height: 150, margin: "0 auto" }}
                        >
                          <Doughnut
                            data={doughnutData}
                            options={{
                              ...doughnutOptions,
                              responsive: false,
                              maintainAspectRatio: false,
                            }}
                            plugins={[centerTextPlugin]}
                          />
                        </div>
                        <div className="p-2">
                          <Row gutter={24} className="container_triptimming">
                            <Col xs={24} sm={12}>
                              {renderLegendItems(left)}
                            </Col>
                            <Col xs={24} sm={12}>
                              {renderLegendItems(right)}
                            </Col>
                          </Row>
                        </div>
                      </Spin>
                    </div>
                  </Card>
                </Col>
              </Row>
            </StyledChartContainer>
            <div className="total">
              <div className="total-header">
                <div className="table-head">
                  <p>{total} Trip Time Reports</p>
                </div>
                <div className="Custom">
                  <Spin spinning={CSVLoader}>
                    {/* <Tooltip title={!exportAllowed ? "No permission" : ""}> */}
                      <img
                        src={ExportIcon}
                        alt="Export"
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: exportAllowed ? "pointer" : "not-allowed",
                          marginRight: "40px",
                          backgroundColor: "#EBF7ED",
                          borderRadius: "6px",
                        }}
                        onClick={() => {
                          if (!exportAllowed) return;
                          prepareCSV();
                        }}
                      />
                    {/* </Tooltip> */}
                  </Spin>
                  <CSVLink
                    data={CSVList}
                    filename={"TripTimeReport.csv"}
                    asyncOnClick={true}
                    ref={csvLinkEl}
                  />
                </div>
              </div>
            </div>
            <div style={report.table}>
              <Spin spinning={loading}>
                {/* <Table dataSource={tripChartData?.TimeReport} columns={columns} /> */}
                <StyledTable
                  className="mt-4"
                  dataSource={tripChartData?.TimeReport}
                  columns={columns}
                  pagination={false}
                  style={{
                    cursor: "default",
                  }}
                  onChange={(pagination, filters, sorter) => {
                    setTableSort({
                      field: sorter.field,
                      order: sorter.order,
                    });
                  }}
                />
                <ReusablePagination
                  pageSize={pageSize}
                  handlePageSizeChange={handlePageSizeChange}
                  currentPage={currentPage}
                  total={total}
                  handlePageChange={handlePageChange}
                />
              </Spin>
            </div>{" "}
          </>
        ) : (
          <>
            <ConsingmentReport
              Tabhidden={tabhidden}
              setTabHidden={setTabHidden}
            />
          </>
        )}
      </StyledChartContainer>
    </Card>
  );
};

export default ReportsPage;
